














interface Pos {
  left: number; // 当前激活 item 的 left offset
  width: number; // 当前激活 item 的宽度
}

function tabItemStyle(height: number, pad: number): any {
  const ih = height - 2 * pad - 2;
  return {
    height: `${ih}px`,
    'line-height': `${ih}px`,
    'border-radius': `${ ih / 2 }px`,
  }
}

export interface Opt {
  label: string;
  value: any;
};

import Vue from 'vue';
export default Vue.extend({
  props: {
    options: {
      type: Array as () => Array<Opt>,
      required: true,
    },
    height: {
      type: Number,
      default: 30,
    },
    pad: {
      type: Number,
      default: 2,
    },
    'defaultValue': {
    },
  },
  computed: {
    transformStyle(): any {
      const tabStyle = tabItemStyle(this.height, this.pad);
      if (this.pos) {
        tabStyle.left = `${this.pos.left}px`;
        tabStyle.width = `${this.pos.width}px`;
      }
      return tabStyle;
    },
    tabStyle(): any {
      return {
        height: `${this.height}px`,
        padding: `${this.pad}px ${this.pad}px`,
        'border-radius': `${this.height / 2}px`,
      }
    },
    tabItemStyle(): any {
      return tabItemStyle(this.height, this.pad);
    },
  },
  methods: {
    getCurrPos(selectTab: HTMLElement): Pos {
      const width = selectTab.offsetWidth;
      const left = selectTab.offsetLeft;
      return {
        width,
        left,
      };
    },
    change(idx: number, v: any, evt: any): void {
      this.currIdx = idx;
      this.$emit('change', v);
      this.pos = this.getCurrPos(evt.target);
    },
    initTab(): void {
      const initTab = (this.$refs.uiTab as HTMLElement).querySelector(`li:nth-child(${this.currIdx + 1})`);
      this.pos = this.getCurrPos(initTab as HTMLElement);
    },
  },
  mounted() {
    this.$nextTick(() => {
      let idx = 0;
      this.options.forEach((d, i) => {
        if(d.value === this.defaultValue) {
          idx = i;
        }
      });
      this.currIdx = idx;
      this.initTab();
    });
  },
  data() {
    return {
      currIdx: 0,
      pos: undefined as Pos | undefined,
    }
  },
});
